import { cn } from "../../lib/utils";

interface EarningsSkeletonProps {
  className?: string;
}

export function EarningsSummarySkeleton({ className }: EarningsSkeletonProps) {
  return (
    <div className={cn("rounded-lg border bg-white p-4 space-y-3", className)}>
      <div className="h-4 bg-gray-200 rounded animate-pulse w-24" />
      <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
      <div className="h-3 bg-gray-200 rounded animate-pulse w-16" />
    </div>
  );
}

export function PayoutDetailsSkeleton({ className }: EarningsSkeletonProps) {
  return (
    <div className={cn("rounded-lg border bg-white p-4 space-y-4", className)}>
      <div className="h-5 bg-gray-200 rounded animate-pulse w-32" />
      <div className="space-y-3">
        <div className="flex justify-between">
          <div className="h-4 bg-gray-200 rounded animate-pulse w-24" />
          <div className="h-4 bg-gray-200 rounded animate-pulse w-16" />
        </div>
        <div className="flex justify-between">
          <div className="h-4 bg-gray-200 rounded animate-pulse w-20" />
          <div className="h-4 bg-gray-200 rounded animate-pulse w-24" />
        </div>
        <div className="flex justify-between">
          <div className="h-4 bg-gray-200 rounded animate-pulse w-28" />
          <div className="h-4 bg-gray-200 rounded animate-pulse w-20" />
        </div>
      </div>
    </div>
  );
}

export function EarningsPeriodSkeleton({ className }: EarningsSkeletonProps) {
  return (
    <div className={cn("rounded-lg border bg-white p-4 space-y-3", className)}>
      <div className="flex justify-between items-start">
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded animate-pulse w-20" />
          <div className="h-3 bg-gray-200 rounded animate-pulse w-32" />
        </div>
        <div className="h-5 bg-gray-200 rounded animate-pulse w-16" />
      </div>
      <div className="flex gap-2">
        <div className="h-6 bg-gray-200 rounded-full animate-pulse w-24" />
        <div className="h-6 bg-gray-200 rounded-full animate-pulse w-20" />
      </div>
    </div>
  );
}

export function EarningsPageSkeleton() {
  return (
    <div className="px-4 pt-4 pb-32 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-2">
        <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse" />
        <div className="h-5 bg-gray-200 rounded animate-pulse w-20" />
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <EarningsSummarySkeleton />
        <EarningsSummarySkeleton />
      </div>

      {/* Payout Details */}
      <PayoutDetailsSkeleton />

      {/* Earnings Section */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="h-5 bg-gray-200 rounded animate-pulse w-16" />
          <div className="flex gap-2">
            <div className="h-8 bg-gray-200 rounded animate-pulse w-16" />
            <div className="h-8 bg-gray-200 rounded animate-pulse w-18" />
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <EarningsPeriodSkeleton />
          <EarningsPeriodSkeleton />
          <EarningsPeriodSkeleton />
          <EarningsPeriodSkeleton />
        </div>
      </div>
    </div>
  );
}